module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "builder__text-option"
  }, [_c('div', {
    staticClass: "builder__text-option-name"
  }, [_c('label', {
    attrs: {
      "for": _vm.domId
    }
  }, [_vm._v(_vm._s(_vm.option.title) + ":")])]), _vm._v(" "), _c('div', {
    staticClass: "builder__text-option-choice"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "builder__text-option-choice-input",
    attrs: {
      "id": _vm.domId,
      "maxlength": (_vm.option.character_limit ? _vm.option.character_limit : '')
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b9859bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/option-types/Hidden.vue
// module id = 369
// module chunks = 0